// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1XGX9","rootSmall":"AddTileButton_rootSmall__2VPbm"};